/* Administration — the same list the sidebar draws under that heading.
 *
 * For a phone, where the sidebar is hidden: the account menu opens this. On a
 * wide screen it is still a fair page to land on from an old link. Somebody
 * with nothing to administer is told so rather than shown an empty list.
 */
import { Link } from 'react-router-dom'
import { ChevronRight, Shield } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { useAdminItems } from '@/components/adminMenu'
import { useMe } from '@/api/queries'

export function AdministrationPage() {
  const { data: me } = useMe()
  const items = useAdminItems()

  if (!me) return null

  return (
    <div className="space-y-s4">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Administration</h1>
        {me.church_name ? (
          <p className="mt-1 text-base text-ink-2">{me.church_name}</p>
        ) : null}
      </header>

      {items.length ? (
        <Card className="divide-y divide-line-2 overflow-hidden">
          {items.map(({ label, icon: Icon, to, blurb }) => (
            <Link
              key={to}
              to={to}
              className="flex items-center gap-s3 px-s4 py-s3 transition-colors hover:bg-hover"
            >
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-pill bg-brand-soft text-brand">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-md font-semibold">{label}</span>
                <span className="block text-sm text-ink-2">{blurb}</span>
              </span>
              <ChevronRight className="h-5 w-5 shrink-0 text-ink-3" aria-hidden />
            </Link>
          ))}
        </Card>
      ) : (
        <Card className="p-s8 text-center">
          <Shield className="mx-auto h-8 w-8 text-ink-2" aria-hidden />
          <p className="mt-s3 text-md font-bold">Nothing to administer</p>
          <p className="mt-1 text-base text-ink-2">
            Your church's administrator can give you a role that includes these.
          </p>
        </Card>
      )}
    </div>
  )
}
